module.exports = __webpack_public_path__ + "assets/img/consideration-4-etapes-implanter-ged.630d6d3d.jpg";